import React, { ReactNode, useEffect, useState } from "react";
import { Resource, Scope } from "../../../../../../types/NendaTypes";
import PermissionsGate from "../../../components/PermissionGate";
import { t } from "i18next";
import { BsCollectionPlayFill } from "react-icons/bs";
import { Form, Formik } from "formik";
import { Modal } from "../../../../Modal/Modal";
import { FormField } from "../../../../Form/FormField";
import { BasicTable } from "../../../../Table/BasicTable";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffectNotOnMount } from "../../../../../hooks/useEffectNotOnMount";
import * as Yup from "yup";
import { store } from "../../../store";
import {
  CreateCollectionAction,
  GetCollectionsAction,
  getMediaCollectionSelector,
  getMediaCollectionsSelector,
} from "../../../store/reducers/cmsReducer";
import CMSPageHeader from "../../../ui-components/pageLayout/CMSPageHeader";
import { ModalWrapper } from "../../../ui-components/pageLayout/ModalComponents";
import { CollectionsPageTableSettings } from "./MediaCollectionsTableSettings";

interface CreateCollectionValues {
  name: string;
}

const CreateCollectionSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required*"),
});

const MediaCollections: React.FC = (): ReactNode => {
  const [showForm, setShowForm] = React.useState(false);
  const collections = useSelector(getMediaCollectionsSelector);
  const collection = useSelector(getMediaCollectionSelector);
  const [isCreating, setIsCreating] = useState<boolean>(false);
  const history = useNavigate();

  const fetchCollections = () => {
    store.dispatch(GetCollectionsAction());
  };

  useEffect(() => {
    fetchCollections();
  }, []);

  function submitCreate(values: CreateCollectionValues) {
    setIsCreating(true);
    store.dispatch(CreateCollectionAction(values.name));
  }

  const handleRowClick = (id: string) => {
    redirect(id);
  };

  useEffectNotOnMount(() => {
    if (collection && isCreating) {
      redirect(collection.getUniqueId());
    }
  }, [collection]);

  const redirect = (id) => {
    history(`/admin/offerings/media-collections/${id}`);
  };

  const handleSearch = (searchQuery) => {
    store.dispatch(GetCollectionsAction(searchQuery));
  };

  return (
    <PermissionsGate
      restriction={{
        resource: Resource.Content,
        scopes: [Scope.CanAdministrate],
      }}
    >
      <>
        <CMSPageHeader
          title={t("customerportal.pages.media_collections.title")}
          count={collections.length}
          button={{
            title: t("customerportal.pages.media_collections.create"),
            onClick: () => setShowForm(true),
            icon: BsCollectionPlayFill,
          }}
          onSearch={handleSearch}
        />
        <Formik
          initialValues={{
            name: "",
          }}
          validationSchema={CreateCollectionSchema}
          onSubmit={(values: CreateCollectionValues) => {
            submitCreate(values);
            setShowForm(false);
          }}
        >
          {({ handleSubmit }) => (
            <Form>
              <ModalWrapper>
                <Modal
                  style={{}}
                  visible={showForm}
                  onClose={() => setShowForm(false)}
                  title={"Create new media collection"}
                  onSubmit={handleSubmit}
                  confirmText="Create"
                  closeOnSubmit={false}
                >
                  <FormField
                    name="name"
                    label="name"
                    placeholder="Media collection Name..."
                  />
                </Modal>
              </ModalWrapper>
            </Form>
          )}
        </Formik>
        <BasicTable
          tableSettings={CollectionsPageTableSettings}
          tableData={collections || []}
          onRowClick={handleRowClick}
        />
      </>
    </PermissionsGate>
  );
};

export default MediaCollections;
